import { MAIN_CONTENT_ID } from 'screens/ProseEdit/Constants'
import { useEffect, useState } from 'react'

import { SUPPORTED_HEADING_LEVELS } from './constants'
import { useEditorDoc } from 'common/Prose/EditorProvider/hooks/useEditorDoc'
import { useLocalDebouncedFn } from 'hooks/useLocalDebouncedFn'

const SCROLL_DEBOUNCE_TIME = 100

// NOTE: find the closest heading that is after the top of the editor
const determineActiveHeading = (callback: (index: number | null) => void) => () => {
  const mainContentElement = document.getElementById(MAIN_CONTENT_ID)
  if (!mainContentElement) return 0

  const { top: editorTop } = mainContentElement.getBoundingClientRect()

  const headings = Array.from(
    mainContentElement.querySelectorAll(SUPPORTED_HEADING_LEVELS.map((level) => `.ProseMirror > h${level}`).join(',')),
  )
  const activeHeadingIndex = headings.findIndex((heading) => {
    const { top } = heading.getBoundingClientRect()

    return top >= editorTop
  })

  callback(activeHeadingIndex)
}

export const useActiveHeadingIndex = () => {
  const [headingIndex, setHeadingIndex] = useState<number | null>(0)
  const debouncedDetermineActiveHeading = useLocalDebouncedFn(
    determineActiveHeading(setHeadingIndex),
    SCROLL_DEBOUNCE_TIME,
  )
  const doc = useEditorDoc()

  const docJSON = doc.toJSON()

  useEffect(() => {
    determineActiveHeading(setHeadingIndex)()
  }, [docJSON])

  useEffect(() => {
    const editorScrollElement = document.getElementById(MAIN_CONTENT_ID)
    if (!editorScrollElement) return

    editorScrollElement.addEventListener('scroll', debouncedDetermineActiveHeading)

    return () => editorScrollElement.removeEventListener('scroll', debouncedDetermineActiveHeading)
  }, [debouncedDetermineActiveHeading])

  return headingIndex
}
